import { formatLoadAndReps } from '../../domain/workouts/describeLift';
import type { LiftBest, LiftHighlights } from '../../domain/workouts/liftHighlights';
import './LiftBests.css';

/** "Aug 12" - built from the parts so it does not read a day early west of UTC. */
function formatBestDate(workoutDate: string): string {
  const [year, month, day] = workoutDate.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  });
}

/**
 * One record line: when it was set, what was lifted, what that works out to as a
 * one-rep max, and what it scored.
 *
 * The points are the ones it earned on the day, not a fresh calculation. On the
 * what-if screen the body weight and sex are editable, and a past lift must not
 * re-score itself because you typed a different number into a calculator.
 */
function BestRow({ label, best }: { label: 'PR' | 'MB'; best: LiftBest | undefined }) {
  const modifier = label === 'PR' ? 'pr' : 'month';
  return (
    <div className="lift-best">
      <span className={`lift-best__badge lift-best__badge--${modifier}`}>{label}</span>
      {best ? (
        <span className="lift-best__detail">
          {formatBestDate(best.workoutDate)} · {formatLoadAndReps(best)} ·{' '}
          {Math.round(best.estimated1RmLb)} lb 1RM · {Math.round(best.points)} pts
        </span>
      ) : (
        <span className="lift-best__detail lift-best__detail--empty">
          {label === 'PR' ? 'No lifts yet' : 'None this month'}
        </span>
      )}
    </div>
  );
}

/**
 * A lift's personal best and its best this month.
 *
 * Shared by the log form and the what-if calculator so the same two lines mean
 * the same thing in both, and follow whichever exercise is selected.
 */
export function LiftBests({ highlights }: { highlights: LiftHighlights | undefined }) {
  return (
    <div className="lift-bests">
      <BestRow label="PR" best={highlights?.pr} />
      <BestRow label="MB" best={highlights?.monthBest} />
    </div>
  );
}
